import { VolleyballIncidentId } from '@collector/sportsapi-client-legacy'

import { CustomIncidentNames } from '../../configuration'

export const customIncidentNames: CustomIncidentNames<VolleyballIncidentId> =
  new Map([
    [VolleyballIncidentId.TechnicalErrors, 'Technical error'],
    [VolleyballIncidentId.AttackPoint, 'Attack point'],
    [VolleyballIncidentId.AttackError, 'Attack error'],
  ])
